//#region types
import { TimeReportingProjectFormViewProps } from "models/propTypes/timeReportingProjectPropTypes";
import { GenericFormSection } from "models/propTypes/genericFormProps";
import { TimeReportingProjectFormTypes } from "models/formTypes";
import { TranslationKeys } from "translations";
import { FormEnums } from "models/enums";
import { IconDefinitionConstants } from "utils/constants";
//#endregion
//#region components
import { useSearchService } from "serviceHooks";
//#endregion

function useInvoicingFields(
  props: TimeReportingProjectFormViewProps
): GenericFormSection<TimeReportingProjectFormTypes.Create>[] {
  const searchService = useSearchService();
  const { invoiceTimeReportDetailLevels, onCurrencyChange } = props;

  return [
    {
      label: "",
      type: FormEnums.FormSectionType.FIELDGROUPSECTION,
      innerFields: {
        isBundledInvoice: {
          label: TranslationKeys.TimeReportingProject.BundledInvoice,
          descriptionText: TranslationKeys.TimeReportingProject.BundledInvoiceDescription,
          type: FormEnums.FormFieldType.TOGGLE,
        },
        invoiceTimeReportDetailLevel: {
          label: TranslationKeys.TimeReportingProject.InvoiceTimeReportDetailLevel,
          descriptionText: TranslationKeys.TimeReportingProject.InvoiceTimeReportDetailLevelDescription,
          type: FormEnums.FormFieldType.CHOICE,
          extraProps: {
            items: invoiceTimeReportDetailLevels,
          },
          hidden: (values: TimeReportingProjectFormTypes.Create) => values.isBundledInvoice,
        },
        includeAttachmentsOnInvoice: {
          label: TranslationKeys.TimeReportingProject.IncludeAttachmentsOnInvoice,
          descriptionText: TranslationKeys.TimeReportingProject.IncludeAttachmentsOnInvoiceDescription,
          type: FormEnums.FormFieldType.TOGGLE,
        },
        includeCommentsOnAttachments: {
          label: TranslationKeys.TimeReportingProject.IncludeCommentsOnAttachments,
          descriptionText: TranslationKeys.TimeReportingProject.IncludeCommentsOnAttachmentsDescription,
          type: FormEnums.FormFieldType.TOGGLE,
          hidden: (values: TimeReportingProjectFormTypes.Create) => values.includeAttachmentsOnInvoice === false,
        },
        currency: {
          label: TranslationKeys.Common.Currency,
          descriptionText: TranslationKeys.TimeReportingProject.CurrencyDescription,
          type: FormEnums.FormFieldType.AUTOCOMPLETE,
          icon: IconDefinitionConstants.WMoney,
          onChangeHandler: onCurrencyChange,
          extraProps: {
            items: searchService.currency,
          },
        },
        hasSellerDimensionInInvoice: {
          label: TranslationKeys.TimeReportingProject.SellerTagActivateOnInvoice,
          descriptionText: TranslationKeys.TimeReportingProject.SellerTagActivateOnInvoiceDescription,
          type: FormEnums.FormFieldType.TOGGLE,
        },
        periodisationEnabled: {
          label: TranslationKeys.TimeReportingProject.PeriodisationEnabled,
          descriptionText: TranslationKeys.TimeReportingProject.PeriodisationEnabledDescription,
          type: FormEnums.FormFieldType.TOGGLE,
        },
      },
    },
  ];
}

export default useInvoicingFields;
